/**
 * Compact relative-time formatter for "X min ago" style timestamps in
 * inspector callouts, list rows, and toasts. Falls back to a localized
 * date string after a week so older entries don't read as e.g. "30 days
 * ago" which feels sloppier than the actual date.
 */
export function formatRelative(epochMs: number): string {
  const diff = Date.now() - epochMs;
  const sec = Math.round(diff / 1000);
  if (sec < 45) return "just now";
  const min = Math.round(sec / 60);
  if (min < 60) return `${min} min ago`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `${hr} hr ago`;
  const day = Math.round(hr / 24);
  if (day < 7) return `${day} day${day === 1 ? "" : "s"} ago`;
  return new Date(epochMs).toLocaleDateString();
}
